import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

interface RouteTransitionProps {
  children: React.ReactNode;
}

export default function RouteTransition({ children }: RouteTransitionProps) {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      className="route-fade"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.33, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
